import {
  CommandComplete,
  CommandDraw,
  CommandFinish,
  CommandPickTarget,
  CommandSkip,
  CommandStart,
  CommandUseRescuer,
  type PlayerID,
} from '@/api/generated/game';

import type { Intent } from './types';

/**
 * Конструкторы намерений. Строковые литералы берутся из сгенерированного
 * контракта, а не пишутся здесь: переименование команды на сервере обязано
 * ломать сборку клиента.
 *
 * `seat` не проставляется как undefined — при exactOptionalPropertyTypes это
 * не то же самое, что отсутствующее поле, и уедет в JSON лишним ключом.
 */
export const intents = {
  start: (actor: PlayerID): Intent => ({ type: CommandStart, actor }),
  draw: (actor: PlayerID): Intent => ({ type: CommandDraw, actor }),
  complete: (actor: PlayerID): Intent => ({ type: CommandComplete, actor }),
  skip: (actor: PlayerID): Intent => ({ type: CommandSkip, actor }),
  finish: (actor: PlayerID): Intent => ({ type: CommandFinish, actor }),
  pickTarget: (actor: PlayerID, seat: number): Intent => ({
    type: CommandPickTarget,
    actor,
    seat,
  }),
  useRescuer: (actor: PlayerID, seat: number): Intent => ({
    type: CommandUseRescuer,
    actor,
    seat,
  }),
} as const;
